import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ComponenteSpinner } from '../pages/adminComponents/ComponenteSpinner';
import { isAllowedRedirect, nonce, saveState, base64url } from '../auth/authUtils';

export const LoginGoogle = () => {
  const nav = useNavigate();
  const { search } = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const redirect = params.get('redirect') || '';
    const redirectNoAuth = params.get("noauth") || "";

    //0) Validar que redirect y redirectNoAuth son el mismo dominio
    const url = new URL(redirect, window.location.origin);
    const urlNoAuth = new URL(redirectNoAuth, window.location.origin);

    const cleanRedirect = url.origin;
    const cleanRedirectNoAuth = urlNoAuth.origin;

    if (redirectNoAuth && cleanRedirect !== cleanRedirectNoAuth) {
      alert('redirect no coincide');
      nav('/inicio', { replace: true });
      return;
    }

    // 1) Validar redirect contra allow-list (.env REACT_APP_ALLOWED_REDIRECTS)
    if (!redirect || !isAllowedRedirect(redirect) || (redirectNoAuth && !isAllowedRedirect(redirectNoAuth))) {
      alert('redirect inválido o no permitido');
      nav('/inicio', { replace: true });
      return;
    }

    if (redirectNoAuth) {
      if (!sessionStorage.getItem("redirect_after_no_auth")) {
          sessionStorage.setItem("redirect_after_no_auth", redirectNoAuth);
      }
    }

    // 2) Construir y guardar state (incluye redirect)
    const st = { n: nonce(), t: Date.now(), r: redirect };
    saveState(st);
    const encodedState = base64url(JSON.stringify(st));

    // 3) Inicializar Google Identity Services (Authorization Code Flow)
    const cid = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    const redirectUri = `${window.location.origin}/oauth2/callback/google`;

    const start = () => {
      const client = window.google.accounts.oauth2.initCodeClient({
        client_id: cid,
        scope: 'openid email profile',
        redirect_uri: redirectUri,
        state: encodedState,
        ux_mode: 'redirect',
      });
      client.requestCode();
    };

    // Esperar a que cargue el script GIS (ya agregaste <script src="https://accounts.google.com/gsi/client">)
    if (window.google?.accounts?.oauth2?.initCodeClient) start();
    else {
      const id = setInterval(() => {
        if (window.google?.accounts?.oauth2?.initCodeClient) {
          clearInterval(id);
          start();
        }
      }, 50);
      setTimeout(() => clearInterval(id), 5000); // opcional
    }
  }, [search, nav]);

  return <ComponenteSpinner />;
};

export default LoginGoogle;